import { CoreApiVersionPath, RosaCoreApiService } from '@/rosa';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import type { ClassificationNodeId } from '../../interfaces/Classification.interface';
import type { Comparison } from '../../interfaces/comparison.interface';

@Injectable({
    providedIn: 'root'
})
export class AdvizeoCoreBuildingsComparisonProvider {
    private _rosaCoreApiService = inject(RosaCoreApiService);

    fetchComparisons$(): Observable<Comparison[]> {
        return this._rosaCoreApiService.get(`${CoreApiVersionPath.V3}comparisons`);
    }

    fetchComparisonPeriods$(classificationNodeId: ClassificationNodeId): Observable<number[]> {
        return this._rosaCoreApiService.post(`${CoreApiVersionPath.V3}buildings/indicators/periods`, { classificationNodeId });
    }
}
